module.exports = __webpack_public_path__ + "img/laser-left.c0f62a8.jpg";